import type { Contract, LineDetails } from "@/types/contract"

export type ServiceKind = "rack" | "insurance"

export function isLegalAddress(contract: Contract): boolean {
  return contract.type === "legal_address"
}

/** What the box is: its unit type's name, or its area when the type is not among the facility's. */
export function unitTypeLabel(contract: Contract): string | null {
  if (contract.unitTypeItem?.name) {
    return contract.unitTypeItem.name
  }

  const surface = contract.unitTypeItem?.surface || contract.surface
  return surface ? `${surface} м²` : null
}

export type ServiceLineDetails = LineDetails & {
  line: NonNullable<LineDetails["line"]> & { kind: ServiceKind }
}

export function isServiceKind(kind: string): kind is ServiceKind {
  return kind === "rack" || kind === "insurance"
}

/**
 * The add-on services currently attached to a contract (rack, insurance), for the
 * chips on its card. The primary line is the box the card already stands for, so
 * it's excluded by id as well as by kind.
 */
export function currentServiceLines(
  lineDetails: LineDetails[] | undefined,
  primaryLineId: number | null | undefined,
): ServiceLineDetails[] {
  return (lineDetails ?? []).filter(
    (ld): ld is ServiceLineDetails =>
      ld.line !== null &&
      ld.line.id !== primaryLineId &&
      ld.line.endedAt === null &&
      isServiceKind(ld.line.kind),
  )
}
